import { bestSellingProductsInitialState, BestSellingProductsState } from './best-selling-products.state';
import { BestSellingProductsActionsUnion, BestSellingProductsActionTypes } from './best-selling-products.actions';

export function bestSellingProductsReducer(
  state: BestSellingProductsState = bestSellingProductsInitialState,
  action: BestSellingProductsActionsUnion) {

  switch (action.type) {
    case BestSellingProductsActionTypes.LOAD_BEST_SELLING_PRODUCTS:
      return { ...state, loading: true };
    case BestSellingProductsActionTypes.LOAD_BEST_SELLING_PRODUCTS_SUCCESS:
      return {
        ...state,
        payload: action.payload.products,
        loading: false,
      };
    case BestSellingProductsActionTypes.LOAD_BEST_SELLING_PRODUCTS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    default:
      return state;
  }
}
